import { createSlice } from "@reduxjs/toolkit";
import { ScrewReducerType } from "../../types/ScrewTypes";

const initialState: ScrewReducerType = {
  // Screw properties related
  screwFetchStatus: "idle",
  screwProperties: null,
  screwData: null,
  
  // Property ID mappings
  propertyIdMappings: {},

  // Uploading screw image
  screwUploadStatus: "idle",
  uploadedScrewData: null,

  // Adding screw to dataset
  addNewScrewStatus: "idle",
  newScrewData: null,

  // Selecting a screw from the grid
  activeScrew: null,

  // Update Existing screw
  screwUpdateStatus: "idle",

  // Filtering conditions
  screwFilters: {
  },

  screwsTotalAmount: 0,
};

const ScrewSlice = createSlice({
  name: "ScrewReducer",
  initialState,
  reducers: {
    updateScrewFetchStatus: (nextState, { payload }) => {
      nextState.screwFetchStatus = payload;
    },
    updateScrewProperties: (nextState, { payload }) => {
      nextState.screwProperties = payload;
    },
    updateScrewData: (nextState, { payload }) => {
      if (!payload) {
        nextState.screwData = null;
        nextState.screwsTotalAmount = 0;
        return;
      }
      nextState.screwData = payload.items;
      nextState.screwsTotalAmount = payload.total;
    },

    // Uploading screw image
    updateScrewUploadStatus: (nextState, { payload }) => {
      nextState.screwUploadStatus = payload;
    },
    updateUploadedScrewData: (nextState, { payload }) => {
      nextState.uploadedScrewData = payload;
    },

    // Adding screw to dataset
    updateAddScrewStatus: (nextState, { payload }) => {
      nextState.addNewScrewStatus = payload;
    },
    updateNewScrewData: (nextState, { payload }) => {
      nextState.newScrewData = payload;
    },

    // =====
    updateActiveScrew: (nextState, { payload }) => {
      nextState.activeScrew = typeof payload === 'function' 
        ? payload(nextState.activeScrew)
        : payload;
      nextState.screwUpdateStatus = "idle";
    },

    setScrewUpdateStatus: (nextState, { payload }) => {
      nextState.screwUpdateStatus = payload;
    },

    // Screws filtering
    updateScrewFilters: (nextState, { payload }) => {
      nextState.screwFilters = payload;
      nextState.activeScrew = null;
    },

    resetScrewUpload: (nextState) => {
      nextState.screwUploadStatus = "idle";
      nextState.uploadedScrewData = null;
      nextState.addNewScrewStatus = "idle";
      nextState.newScrewData = null;
    },

    // Reset state
    resetScrewSlice: (nextState) => {
      Object.keys(initialState).map(
        (key) =>
          (nextState[key as keyof typeof initialState] =
            initialState[key as keyof typeof initialState])
      );
    },

    updatePropertyIdMappings: (nextState, { payload }) => {
      nextState.propertyIdMappings = payload;
    },
  },
});

export const { reducer: ScrewReducer } = ScrewSlice;
export const {
  updateScrewFetchStatus,
  updateScrewProperties,
  updateScrewData,
  updateScrewUploadStatus,
  updateUploadedScrewData,
  updateAddScrewStatus,
  updateNewScrewData,
  updateActiveScrew,
  resetScrewUpload,
  resetScrewSlice,
  updateScrewFilters,
  setScrewUpdateStatus,
  updatePropertyIdMappings,
} = ScrewSlice.actions;
